export default error => {
  if (!error) {
    return '-';
  }
  //todo json viewer
  const jsonData = JSON.parse(error);

  let output = '';

  if (jsonData?.RODZAJ_BLEDU !== undefined) {
    return `${ jsonData?.RODZAJ_BLEDU || 'Błąd' }: ${ jsonData?.OPIS_ROZWIAZANIE || '-' }\n\n`;
  }

  for (let i = 0; i < jsonData.length; i++) {
    const errors = jsonData[i];
    output += `${ i + 1 }. ${ errors?.RODZAJ_BLEDU || 'Błąd' }: ${ errors?.OPIS_ROZWIAZANIE || '-' }`;

    if (i === jsonData.length - 1) {
      output += `\n\n`;
    }
  }
  return output;
}
